import axios from "axios";
import { API_BASE_URL } from "@/config.js";

export function getFilenameFromContentDisposition(
  contentDisposition,
  fallback
) {
  if (!contentDisposition) {
    return fallback;
  }

  const utfMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utfMatch?.[1]) {
    return decodeURIComponent(utfMatch[1]);
  }

  const asciiMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
  if (asciiMatch?.[1]) {
    return asciiMatch[1].replace(/['"]/g, "").trim();
  }

  return fallback;
}

export function downloadBlob(data, fallbackFileName, contentDisposition = "") {
  const blob = data instanceof Blob ? data : new Blob([data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = getFilenameFromContentDisposition(
    contentDisposition,
    fallbackFileName
  );
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export async function downloadModello(tipo, fallbackFileName) {
  const response = await axios.get(`${API_BASE_URL}/download_modello`, {
    params: { tipo },
    responseType: "blob",
  });

  downloadBlob(
    response.data,
    fallbackFileName,
    response.headers["content-disposition"]
  );
}
